var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramValuable48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Small./Valuable48",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "Valuable48",
    transform: "translate(5.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "diamond-white",
    fill: "#FFFFFF",
    points: "8 0 19 0 30 0 38 12 19 37 0 12"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Focus",
    fill: "#FFCC00",
    points: "37.0016479 10.9976807 19 36.9974976 26.0040894 10.9976807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3261784,11.1 L19,32.0570254 L25.6738216,11.1 L19,1.53307297 L12.3261784,11.1 Z M27.3261784,11 L19,36.9429746 L10.6738216,11 L18.2275576,0 L19.7724424,0 L27.3261784,11 Z",
    id: "diamond-inside",
    fill: "#4F4C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40138782,0.75 L0.920374403,11.9715201 L19,35.7605012 L37.0796256,11.9715201 L29.5986122,0.75 L8.40138782,0.75 Z",
    id: "diamond-border",
    stroke: "#4F4C4D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "line",
    fill: "#4F4C4D",
    points: "1.5 12.5 1.5 11 37 11 37 12.5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramValuable48);
export default __webpack_public_path__ + "static/media/pictogramValuable48.a149725c70faa05c71df543c9e19021a.svg";
export { ForwardRef as ReactComponent };